import MenuOption, { MenuOptionProps } from '../Menu/MenuOption';

export default function InputOption(props: MenuOptionProps) {
    return (
        <MenuOption {...props}></MenuOption>
    )
}
